var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorktime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 7,
    fill: "url(#paint0_linear_1_647)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 13.9999C21 13.4477 20.5523 12.9999 20 12.9999C19.4477 12.9999 19 13.4477 19 13.9999V19.9999C19 20.3787 19.214 20.725 19.5528 20.8944L23.5528 22.8944C24.0468 23.1414 24.6475 22.9411 24.8945 22.4472C25.1414 21.9532 24.9412 21.3525 24.4472 21.1055L21 19.3819V13.9999Z",
    fill: "#007675"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 8.99994C13.9249 8.99994 9.00003 13.9248 9.00003 19.9999C9.00003 26.0751 13.9249 30.9999 20 30.9999C26.0752 30.9999 31 26.0751 31 19.9999C31 13.9248 26.0752 8.99994 20 8.99994ZM11 19.9999C11 15.0294 15.0295 10.9999 20 10.9999C24.9706 10.9999 29 15.0294 29 19.9999C29 24.9705 24.9706 28.9999 20 28.9999C15.0295 28.9999 11 24.9705 11 19.9999Z",
    fill: "#007675"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_647",
    x1: 49.5,
    y1: 40,
    x2: -10.5,
    y2: 2.49999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007675",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007675",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorktime);
export default __webpack_public_path__ + "static/media/worktime.92aa145ed05f75b250aa2c1414f33098.svg";
export { ForwardRef as ReactComponent };